(function () {
  'use strict';

  var HEADER_OFFSET = 90;
  var revealObserver = null;

  function getRevealObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
    );
    return revealObserver;
  }

  function initReveal(root) {
    var targets = (root || document).querySelectorAll('[data-ls-reveal]:not(.is-in)');
    var observer = getRevealObserver();
    Array.prototype.forEach.call(targets, function (el, i) {
      el.style.transitionDelay = (i % 3) * 0.07 + 's';
      if (observer) {
        observer.observe(el);
      } else {
        el.classList.add('is-in');
      }
    });
    window.setTimeout(function () {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
    }, 4000);
  }

  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ls-scroll]');
    if (!trigger) return;
    var id = trigger.getAttribute('data-ls-scroll');
    if (!document.getElementById(id)) return;
    event.preventDefault();
    scrollToId(id);
    var openMenu = trigger.closest('details[open]');
    if (openMenu) openMenu.removeAttribute('open');
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.ls-acc__btn');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var group = btn.closest('[data-ls-acc-group]');
    var isOpen = btn.getAttribute('aria-expanded') === 'true';

    if (group && group.getAttribute('data-ls-acc-group') === 'single') {
      group.querySelectorAll('.ls-acc__btn[aria-expanded="true"]').forEach(function (other) {
        if (other === btn) return;
        other.setAttribute('aria-expanded', 'false');
        var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
        if (otherPanel) {
          otherPanel.style.maxHeight = '0px';
          otherPanel.classList.remove('is-open');
        }
      });
    }

    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (isOpen) {
      panel.style.maxHeight = '0px';
      panel.classList.remove('is-open');
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.classList.add('is-open');
    }
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.ls-acc__panel.is-open').forEach(function (panel) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  });

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-ls-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-ls-gallery], [data-ls-gallery-thumbs]');
    var root = thumb.closest('.ls-buy, [data-ls-gallery-root]') || document;
    var index = thumb.getAttribute('data-ls-thumb');

    root.querySelectorAll('[data-ls-shot]').forEach(function (shot) {
      var active = shot.getAttribute('data-ls-shot') === index;
      shot.style.opacity = active ? '1' : '0';
      shot.style.pointerEvents = active ? 'auto' : 'none';
      shot.style.zIndex = active ? '2' : '1';
    });
    root.querySelectorAll('[data-ls-thumb]').forEach(function (other) {
      var active = other === thumb;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-current', active ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-ls-scroller-step]');
    if (!arrow) return;
    var wrapper = arrow.closest('[data-ls-scroller-root]');
    var track = wrapper && wrapper.querySelector('.ls-scroller');
    if (!track) return;
    var cards = track.children;
    if (!cards.length) return;
    var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
    var dir = parseInt(arrow.getAttribute('data-ls-scroller-step'), 10) || 1;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  function onScroll() {
    var doc = document.scrollingElement || document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var top = doc.scrollTop || window.pageYOffset || 0;
    var pct = max > 0 ? Math.min(100, Math.max(0, (top / max) * 100)) : 0;

    document.querySelectorAll('[data-ls-progress]').forEach(function (bar) {
      bar.style.width = pct.toFixed(1) + '%';
    });

    document.querySelectorAll('[data-ls-sticky]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-ls-sticky'), 10) || 620;
      var show = top > threshold;
      bar.style.transform = show ? 'translateY(0%)' : 'translateY(110%)';
      bar.style.opacity = show ? '1' : '0';
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.ls details[open]').forEach(function (node) {
      if (node.contains(event.target)) return;
      node.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ls details[open]').forEach(function (node) {
      node.removeAttribute('open');
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ls-cart-form]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[data-ls-cart-submit]');
    var status = form.querySelector('[data-ls-cart-status]');
    var label = button ? button.querySelector('[data-ls-cart-label]') : null;
    var original = label ? label.textContent : '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding...';
    if (status) status.textContent = '';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function () {
        if (label) label.textContent = 'Added to cart';
        if (status) status.textContent = 'Added to your cart.';
        document.dispatchEvent(new CustomEvent('ls:cart:added'));
        updateCount(root);
        if (form.getAttribute('data-ls-cart-form') === 'checkout') {
          window.location.href = root + 'checkout';
          return;
        }
        window.setTimeout(function () {
          if (label) label.textContent = original;
          if (button) button.disabled = false;
        }, 2200);
      })
      .catch(function () {
        if (label) label.textContent = original;
        if (button) button.disabled = false;
        if (status) status.textContent = 'Could not add that to your cart. Please try again.';
      });
  });

  function updateCount(root) {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ls-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ls-inert-form]');
    if (!form) return;
    event.preventDefault();
    var note = form.querySelector('[data-ls-inert-note]');
    if (note) note.textContent = 'Email sign-up is not connected yet.';
  });

  function boot(root) {
    initReveal(root);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:select', function (event) {
    boot(event.target);
    event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var acc = event.target.querySelector('.ls-acc__btn');
    if (acc && acc.getAttribute('aria-expanded') === 'false') acc.click();
    event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
